export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export class AppSelect extends HTMLElement {
  private _options: SelectOption[] = [];

  static get observedAttributes() {
    return ["label", "value", "disabled", "required", "error", "helper", "multiple", "searchable"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  set options(opts: SelectOption[]) {
    this._options = opts;
    this.render();
  }

  get options(): SelectOption[] {
    return this._options;
  }

  get value(): string | string[] {
    const select = this.querySelector("select");
    if (!select) return "";
    if (this.hasAttribute("multiple")) {
      return Array.from(select.selectedOptions).map(o => o.value);
    }
    return select.value;
  }

  set value(val: string | string[]) {
    const select = this.querySelector("select");
    if (select) {
      if (Array.isArray(val)) {
        for (const opt of Array.from(select.options)) {
          opt.selected = val.includes(opt.value);
        }
      } else {
        select.value = val;
      }
    }
  }

  private render() {
    const label = this.getAttribute("label") || "";
    const currentValue = this.getAttribute("value") || "";
    const disabled = this.hasAttribute("disabled");
    const required = this.hasAttribute("required");
    const error = this.getAttribute("error") || "";
    const helper = this.getAttribute("helper") || "";
    const multiple = this.hasAttribute("multiple");

    const id = `select-${Math.random().toString(36).substring(2, 9)}`;

    // Read child <option> tags if no programmatic options set
    if (this._options.length === 0) {
      const childOptions = this.querySelectorAll("option");
      if (childOptions.length > 0) {
        this._options = Array.from(childOptions).map(opt => ({
          value: opt.value,
          label: opt.textContent || opt.value,
          disabled: opt.disabled
        }));
      }
    }

    const optionsHtml = this._options.map(opt => `
      <option value="${opt.value}" ${opt.value === currentValue ? "selected" : ""} ${opt.disabled ? "disabled" : ""}>
        ${opt.label}
      </option>
    `).join("");

    this.innerHTML = `
      <div class="form-group">
        ${label ? `<label for="${id}" class="form-label ${required ? "required" : ""}">${label}</label>` : ""}
        <select
          id="${id}"
          class="form-select ${error ? "error" : ""}"
          ${multiple ? "multiple" : ""}
          ${disabled ? "disabled" : ""}
          ${required ? "required" : ""}
        >
          ${!multiple ? '<option value="">Selecione uma opção...</option>' : ""}
          ${optionsHtml}
        </select>
        ${error ? `<span class="form-error">${error}</span>` : ""}
        ${helper && !error ? `<span class="form-helper">${helper}</span>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-select")) {
  if (!customElements.get("app-select")) {
    customElements.define("app-select", AppSelect);
  }
}
